<div class="submit-loader" *ngIf="show" aria-live="polite">
  <!-- <div class="loader-card"> -->
  <div class="loader-title">{{ text }}</div>
  <div class="loader-slides">
    <div class="loader-slide s1"></div>
    <div class="loader-slide s2"></div>
    <div class="loader-slide s3"></div>
  </div>
  <!-- </div> -->
</div>
